import type { ReviewTrendMonth } from "../../../types/reviews";

const MIN = 3.0;
const MAX = 5.0;

export function TrendChart({ trend }: { trend: ReviewTrendMonth[] }) {
  if (trend.length === 0) return <div className="rv-empty">推移データがありません。</div>;
  const lastMonth = trend[trend.length - 1]?.month;
  return (
    <div>
      <div className="rv-trend">
        {trend.map((t) => {
          const avg = t.avg ?? MIN;
          const heightPct = Math.max(4, ((avg - MIN) / (MAX - MIN)) * 100);
          return (
            <div className="rv-trend-col" key={t.month}>
              {t.fillRate !== null && <span className="rv-trend-dot" />}
              <span className={`rv-trend-bar ${t.month === lastMonth ? "current" : ""}`} style={{ height: `${heightPct}%` }} />
            </div>
          );
        })}
      </div>
      <div className="rv-trend-labels">
        {trend.map((t) => (
          <div className="rv-trend-label" key={t.month}>
            <span className="rv-trend-value">{t.avg !== null ? t.avg.toFixed(1) : "―"}</span>
            <span>{t.month.slice(5)}月</span>
            <span>{t.fillRate !== null ? `${t.fillRate}%` : "―"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
